import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class LocationLookup extends BaseComponent {

	static get properties() {
		return {
			style: {type: String},
			textstyle: {type: String},
			label: {type: String},
			classes: {type: String},
			required: {type: Boolean},
			name: {type: String}
		};
	}
	
	constructor() {
		super();
		
		var locationLookup = this;	
		locationLookup.style = '';
		locationLookup.textstyle = '';
		locationLookup.label = 'Location';
		locationLookup.name = 'location';
		locationLookup.classes = '';
		locationLookup.required = false,

		setTimeout(function(){
			locationLookup.init();
		});
	}
	
	render() {	
		return html`
			<style>		
				.icon-btn {
					border: 1px solid lightgray;
					padding: 5px;
					margin-bottom: 4px;
					border-radius: 7px 7px 7px 7px;
				}
				.icon-btn:hover {
					background: lightgray;
					cursor: pointer;
				}
			</style>
			<span style="${this.style}" class="${this.classes}">			
				<slot name="text"></slot>
				<span style="width: 40px; height: 40px;">
					<vaadin-icon itemid="lookup-icon" icon="vaadin:globe" class="icon-btn"></vaadin-icon>
				</span>	
				<slot name="suggestions"></slot>
			</span>			
		`;
	}
	
	init() {
		var locationLookup = this;
		
		ElementUtil.query(locationLookup, 'lookup-icon').addEventListener('click', function(){
			actionShowLocationPicker();
		});	
		
		var suggestionMenu = ElementUtil.create({
			tag: 'vaadin-list-box',
			itemid: 'menu',
			slot: 'suggestions',
			style: 'width: 300px; margin-left: 10px; max-height: 250px; overflow: auto;',
			'class': 'suggestions-menu hide'
		});	
				
		var textField = ElementUtil.create({
			tag: 'vaadin-text-field',
			itemid: 'text',
			slot: 'text',
			label: locationLookup.label,
			name: locationLookup.name,
			style: locationLookup.textstyle,
			preventInvalidInput: false,
			listeners: {
				'input': {
					fn: function() {
						if (textField.value && textField.value.length > 3) {
							RoutingService.getPostalCodeService().getPostalCodes({
								distinctCity: true,
								filterField: 'postalCodeCityId.cityName',
								filterValue: textField.value,
								max: 100
							}).then(function(results){
								
								 
								ElementUtil.removeAllChildren(suggestionMenu);
								if (results.data.length > 0) {
							
									results.data.forEach(function(suggestion){
										var item = ElementUtil.create({
											tag: 'vaadin-item',										
											innerHTML: suggestion.postalCodeCityId.cityName + ', ' + suggestion.postalCodeCityId.stateProvCode,
											listeners: {
												click: function(event) {
													textField.value = suggestion.postalCodeCityId.cityName + ', ' + suggestion.postalCodeCityId.stateProvCode;
													suggestionMenu.classList.add('hide');
												}
											}
										});
										suggestionMenu.append(item);
									});

									suggestionMenu.classList.remove('hide');
								} else {
									suggestionMenu.classList.add('hide');
								}
							
							});
						}
					},							
					buffer: 1000
				}
			}		
		});
		if (locationLookup.required) {
			textField.required = true;
		}
		if (locationLookup._pendingValue != null) {
			textField.value = locationLookup._pendingValue;
			locationLookup._pendingValue = null;
		}
		
		locationLookup.append(suggestionMenu);
		locationLookup.append(textField);
		
		document.addEventListener('click', function() {
			if (suggestionMenu && !suggestionMenu.classList.contains('hide')) {
				suggestionMenu.classList.add('hide');
			}
		});		
		
		var actionShowLocationPicker = function() {
			
			var pickerWin = ElementUtil.create({			
				tag: 'dl-dialog',
				title: 'Pick Location',
				icon: 'vaadin:globe',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						pickerWin.show();
						
						var pickerPanel = ElementUtil.create({
							tag: 'vaadin-split-layout',
							style: 'height: 100%;',
							slot: 'primary',
							children: [
								{	
									tag: 'dl-flex-layout',
									style: 'max-width: 25%',
									children: [		
										{
											tag: 'dl-toolbar',											
											slot: 'toolbar',
											theme: 'spacing',
											children: [
												{
													tag: 'vaadin-text-field',
													itemid: 'filterCountry',
													listeners: {
														input: function() {
															filterCountry();
														}
													}
												}
											]
										},
										{
											tag: 'vaadin-grid',
											itemid: 'countryGrid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',			
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},			
											children: [															
												{						
													path: 'description',
													header: 'Country',
													width: '7em'
												}				
											],
											listeners: {
												'active-item-changed': function(event) {
													const item = event.detail.value;
													var countryGrid = ElementUtil.query(pickerPanel, 'countryGrid');
													countryGrid.selectedItems = item ? [item] : [];
													
													if (countryGrid.selectedItems.length > 0) {
														actionLoadStates(item);
													}
												}
											}
										}
									]
								},
								{
									tag: 'vaadin-split-layout',
									style: 'height: 100%;',							
									children: [										
										{
											tag: 'dl-flex-layout',
											children: [		
												{
													tag: 'dl-toolbar',
													slot: 'toolbar',
													theme: 'spacing',
													children: [
														{
															tag: 'vaadin-text-field',
															itemid: 'filterState',
															listeners: {
																input: function() {
																	filterState();
																}
															}
														}
													]
												},
												{
													tag: 'vaadin-grid',
													itemid: 'stateGrid',
													theme: 'row-stripes column-borders',
													'column-reordering-allowed': '',
													style: 'height: 100%;',			
													slot: 'primary',
													defaults: {
														tag: 'vaadin-grid-sort-column',
														resizable: true
													},			
													children: [															
														{						
															path: 'description',
															header: 'State',
															width: '7em'
														}				
													],
													listeners: {
														'active-item-changed': function(event) {
															const item = event.detail.value;			
															var stateGrid = ElementUtil.query(pickerPanel, 'stateGrid');
															stateGrid.selectedItems = item ? [item] : [];
																														
															if (stateGrid.selectedItems.length > 0) {
																actionLoadCities(item);
															}
														}
													}
												}
											]									
										},
										{
											tag: 'dl-flex-layout',
											children: [		
												{
													tag: 'dl-toolbar',
													slot: 'toolbar',
													theme: 'spacing',
													children: [
														{
															tag: 'vaadin-text-field',
															itemid: 'filterCities',
															listeners: {
																input: function() {
																	filterCities();
																}
															}
														}														
													]
												},
												{													
													tag: 'vaadin-grid',
													itemid: 'cityGrid',
													theme: 'row-stripes column-borders',
													'column-reordering-allowed': '',
													style: 'height: 100%;',			
													slot: 'primary',
													defaults: {
														tag: 'vaadin-grid-sort-column',
														resizable: true
													},			
													children: [															
														{						
															path: 'postalCodeCityId.cityName',
															header: 'City',
															width: '7em'
														}				
													],
													listeners: {
														'active-item-changed': function(event) {
															const item = event.detail.value;					
															ElementUtil.query(pickerPanel, 'cityGrid').selectedItems = item ? [item] : [];
														}
													}
												}
											]									
										}
									]
								}
							]
							
						
						});
						
						var toolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'footer',
							theme: 'spacing',
							bodyStyle: 'border-top: 1px solid lightgrey;',
							children: [
								{
									tag: 'vaadin-button',
									'class': 'spacer-toolbar-item',
									children: [
										ElementUtil.makeIcon('vaadin:close', ' Cancel')
									],
									listeners: {
										click: function () {
											pickerWin.close();
										}
									}
								},
								{
									tag: 'vaadin-button',						
									theme: 'primary',												
									'class': 'spacer-toolbar-item',
									style: 'float: right;',
									children:[
										ElementUtil.makeIcon('vaadin:check', ' Select')
									],
									listeners: {
										click: function() {
											actionSelect();
										}
									}
								}
							]
						});
						
						var cityStatePicker = {
							'tab-title': 'City, State Picker',
							tag: 'div',
							style: 'height: 100%;',
							children: [
								pickerPanel
							]
						};
						
						var mapPanel = {
							tag: 'dl-map-panel',
							itemId: 'map',
							style: 'width: 100%; height: 100%',
							mapContainerId: 'pickMapId',
							singleSearch: true
						};
						
						var mapStatusDiv = ElementUtil.create({
							tag: 'div',		
							style: 'position: absolute; bottom: 85px; left: 125px; z-index: 999; padding: 5px; background-color: #00000088; color: white;',
							innerHTML: '0, 0'
						});
						
						var mapPicker = {
							'tab-title': 'Map Picker',
							tag: 'div',
							itemId: 'mapPicker',
							style: 'height: 100%;',
							children: [	
								mapStatusDiv,
								mapPanel
							]
						};
												
						var tabPanel = ElementUtil.create({
							tag: 'dl-tabpanel',
							slot: 'primary',
							listeners: {
								ready: function () {
									tabPanel.addTabs([
										cityStatePicker,
										mapPicker
									]);
								}
							}
						});
						
						var flexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								tabPanel,
								toolbar
							]
						});
						pickerWin.addToContentElement(flexLayout);
						
						setTimeout(function(){
							var mapPanelFull = ElementUtil.query(tabPanel, 'map');
							mapPanelFull.savedMaker = null;
							
							var updateMapStatus = function(lngLat) {
								var lat = Math.round(lngLat.lat*100000)/100000;
								var lng = Math.round(lngLat.lng*100000)/100000;
								mapStatusDiv.innerHTML =  lat + ', ' + lng ;
								mapPanelFull.selectedLat = lat;
								mapPanelFull.selectedLng = lng;
							};
							
							mapPanelFull.map.on('click', function (e) {
								if (!mapPanelFull.savedMaker) {									
									updateMapStatus(e.lngLat);

									mapPanelFull.savedMaker = mapPanelFull.addMarker(e.lngLat, {
										draggable: true
									});
									mapPanelFull.savedMaker.on('drag', function (e){
										updateMapStatus(e.target._lngLat);									
									});
								}
							});
						}, 100);
						
					
						var allCountries = [];
						var allStates = [];
						var allCities = [];
						
						var filterCountry = function() {
							var filter = ElementUtil.query(pickerPanel, 'filterCountry').value;							
							
							var filtered = [];
							allCountries.forEach(function(item){
								var keep = true;
								if (filter !== '' && !item.description.toLowerCase().includes(filter.toLowerCase())) {
									keep = false;
								}
								if (keep) {
									filtered.push(item);
								}
							});							
							
							ElementUtil.query(pickerPanel, 'countryGrid').items = filtered;
						};
						
						var filterState = function() {
							var filter = ElementUtil.query(pickerPanel, 'filterState').value;
							var filtered = [];
							allStates.forEach(function(item){
								var keep = true;
								if (filter !== '' && !item.description.toLowerCase().includes(filter.toLowerCase())) {
									keep = false;
								}
								if (keep) {
									filtered.push(item);
								}
							});							
							
							ElementUtil.query(pickerPanel, 'stateGrid').items = filtered;
						};
						
						var filterCities = function() {
							var filter = ElementUtil.query(pickerPanel, 'filterCities').value;
							
							var filtered = [];
							allCities.forEach(function(item){
								var keep = true;
								if (filter !== '' && !item.postalCodeCityId.cityName.toLowerCase().includes(filter.toLowerCase())) {
									keep = false;
								}
								if (keep) {
									filtered.push(item);
								}
							});							
							
							ElementUtil.query(pickerPanel, 'cityGrid').items = filtered;							
						};
						
												
						var actionLoadCountries = function() {
							//UI needs to render first
							setTimeout(function () {
								var loadMask = ElementUtil.query(pickerPanel, 'countryGrid').showLoading();
								Service.getLookupService().getLookupValues('CountryCode').then(function (data) {
									loadMask.remove();
									allCountries = data.slice();
									filterCountry();
								});
							}, 100);
						};
						actionLoadCountries();
												
						var actionLoadStates = function(country) {							
							if (country) {
								var loadMask = ElementUtil.query(pickerPanel, 'stateGrid').showLoading();
								Service.getLookupService().getLookupValues('StateProvCode').then(function(data) {
									loadMask.remove();
									var countryStates = [];
									data.forEach(function(state){
										if (state.country === country.code) {
											countryStates.push(state); 
										}
									});
									
									allStates = countryStates;
									filterState();
								});
							}
						};
						
						
						var actionLoadCities = function(state) {
							if (state) {
								var loadMask = ElementUtil.query(pickerPanel, 'cityGrid').showLoading();	
								RoutingService.getPostalCodeService().getPostalCodes({
									state: state.code,
									country: state.country,
									distinctCity: true
								}).then(function(cityList) {
									loadMask.remove();
									cityList.data.sort(function(a,b){
										return a.postalCodeCityId.cityName.localeCompare(b.postalCodeCityId.cityName);
									});
									
									allCities = cityList.data.slice();
									filterCities();
								});
							}
						};
						
						var actionSelect = function() {
							//console.log(tabPanel.selectedTab());
							if (tabPanel.selectedTab() === 0) {							
								var country = ElementUtil.query(pickerPanel, 'countryGrid').selectedItems;
								var state = ElementUtil.query(pickerPanel, 'stateGrid').selectedItems[0];
								var city = ElementUtil.query(pickerPanel, 'cityGrid').selectedItems[0];

								if (!state || !city) {
									window.DL.MessageUtil.showOkMessage('Please select a State and City');
								} else {
									ElementUtil.query(locationLookup, 'text').value = city.postalCodeCityId.cityName + ", " + state.code;
									pickerWin.close();								
								}
							} else {
								var mapPanelFull = ElementUtil.query(tabPanel, 'map');
								if (!mapPanelFull.selectedLat && !mapPanelFull.selectedLng) {
									window.DL.MessageUtil.showOkMessage('Please select a Location on the Map');
								} else {
									ElementUtil.query(locationLookup, 'text').value = mapPanelFull.selectedLat + ", " + mapPanelFull.selectedLng;
									pickerWin.close();	
								}
							}
							
						};
						
					}

				}
				
			});
						
		};
		
	}
	
	getValue() {
		var locationLookup = this;
		var textField = ElementUtil.query(locationLookup, 'text');
		if (textField) {
			return textField.value;
		}
		return locationLookup._pendingValue || '';
	}
	
	setValue(newValue) {
		var locationLookup = this;
		var textField = ElementUtil.query(locationLookup, 'text');
		if (textField) {
			textField.value = newValue;
			locationLookup._pendingValue = null;
		} else {
			locationLookup._pendingValue = newValue;
		}
	}

	// Used by dl-form-panel so submit/load use the text field, not a stale property on this element.
	getCustomValue() {
		return this.getValue();
	}

	setCustomValue(newValue) {
		this.setValue(newValue);
	}
	
	markError(message) {
		var locationLookup = this;
		var textField = ElementUtil.query(locationLookup, 'text');
		
		textField.errorMessage = message;
		textField.invalid = true;
	}
	
};
customElements.define('dl-location-lookup', LocationLookup);


